import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';

/**
 * example type upload Item.
 * @typedef {{ file: File, progress: number, state: 'progress' | 'error' | 'done' }}
 *
 */

const initialState = {
	show: false,
	list: [],
	storageExceeded: false,
	storageLimit: null,
	storageUsed: null,
};

const isExceeded = (state) => (
	state.storageLimit !== null && state.storageUsed !== null && state.storageUsed >= state.storageLimit
);

const uploadSlice = createSlice({
	name: 'upload',
	initialState,
	reducers: {
		addUploadItem: (state, action) => {
			state.show = true;
			state.list.unshift({
				file: action.payload.file,
				progress: 0,
				state: 'progress',
			});
		},
		updateUploadItem: (state, action) => {
			const index = state.list.findIndex((item) => action.payload.file.name === item.file.name);
			state.list.splice(index, 1, action.payload);
		},
		toggleShowUpload: (state) => {
			state.show = !state.show;
		},
		closeShowUpload: (state, action) => {
			state.show = action.payload;
		},
		setStorageExceeded: (state, action) => {
			state.storageExceeded = action.payload;
		},
		setStorageUsage: (state, action) => {
			state.storageLimit = action.payload.limit;
			state.storageUsed = action.payload.used;
			state.storageExceeded = isExceeded(state);
		},
		addStorageUsed: (state, action) => {
			if (state.storageUsed === null) return;

			state.storageUsed += Number(action.payload) || 0;
			state.storageExceeded = isExceeded(state);
		},
	},
});

export const {
	addUploadItem, updateUploadItem, toggleShowUpload, closeShowUpload,
	setStorageExceeded, setStorageUsage, addStorageUsed,
} = uploadSlice.actions;

export const fetchStorageUsage = () => async (dispatch) => {
	try {
		const [plan, quota] = await Promise.all([
			api.getAuthorPlan(),
			api.getQuotaUsage(),
		]);

		const limit = plan?.authorStorageQuota ?? null;
		const total = quota?.total;

		if (!limit || !total) return null;

		const used = Number(total.storage ?? 0) + Number(total.cdn ?? 0);

		dispatch(setStorageUsage({ limit, used }));

		return { limit, used };
	} catch (e) {
		console.warn('Failed to load storage quota:', e);
		return null;
	}
};

export default uploadSlice.reducer;
